import React, { useState } from 'react';
import { StyleSheet, TextInput, TouchableOpacity, View } from 'react-native';
import { Color, CommonProperties } from '../styles';
import BaseText from './BaseText';
import RowView from './RowView';

export const PERIODS = {
  am: 'am',
  pm: 'pm',
};

const TimePicker = ({ format = 24, value = {}, onChange }) => {
  const [minutes, setMinutes] = useState(null);
  const [hours, setHours] = useState(null);
  const [period, setPeriod] = useState(PERIODS.am);
  const defineMinutes = (text) => {
    if (text) {
      const number = parseInt(text);
      const hours = value?.hours;

      if (number > 59) {
        onChange({ hours, minutes: '59' });
        //setMinutes(59);
      } else if (number < 0) {
        //setMinutes(0);
        onChange({ hours, minutes: '0' });
      } else {
        //setMinutes(number);
        onChange({ hours, minutes: number.toString() });
      }
    } else {
      onChange({ hours, minutes: null });
      //setMinutes(null);
    }
  };

  const defineHours = (text) => {
    if (text) {
      const maxNumber = format === 12 ? 11 : 23;
      const number = parseInt(text);
      const minutes = value?.minutes;

      if (number > maxNumber) {
        onChange({ minutes, hours: maxNumber.toString() });
        //setHours(maxNumber);
      } else if (number < 0) {
        onChange({ minutes, hours: '0' });
        //setHours(0);
      } else {
        //setHours(number);
        onChange({ minutes, hours: number.toString() });
      }
    } else {
      onChange({ minutes, hours: null });
      //setHours(null);
    }
  };

  // useEffect(() => {
  //   console.log('onchange');
  //   if (hours !== null && minutes !== null) {
  //     onChange({ hours, minutes });
  //   }
  // }, [onChange, minutes, hours]);

  return (
    <View>
      <RowView style={pickerStyles.container}>
        <TextInput
          style={pickerStyles.input}
          placeholderTextColor={Color.text.low}
          placeholder="00"
          value={value?.hours}
          onChangeText={defineHours}
        />
        <BaseText style={pickerStyles.space}>:</BaseText>
        <View>
          <TextInput
            style={pickerStyles.input}
            placeholder="00"
            placeholderTextColor={Color.text.low}
            value={value?.minutes}
            onChangeText={defineMinutes}
          />
        </View>
        {format === 12 && (
          <View style={pickerStyles.twelveSection}>
            <TouchableOpacity onPress={() => setPeriod(PERIODS.am)}>
              <View
                style={[
                  pickerStyles.period,
                  period === PERIODS.am ? pickerStyles.periodSelected : null,
                ]}
              >
                <BaseText
                  style={[
                    pickerStyles.periodText,
                    period === PERIODS.am ? pickerStyles.periodTextSelected : null,
                  ]}
                >
                  AM
                </BaseText>
              </View>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => setPeriod(PERIODS.pm)}>
              <View
                style={[
                  pickerStyles.period,
                  period === PERIODS.pm ? pickerStyles.periodSelected : null,
                ]}
              >
                <BaseText
                  style={[
                    pickerStyles.periodText,
                    period === PERIODS.pm ? pickerStyles.periodTextSelected : null,
                  ]}
                >
                  PM
                </BaseText>
              </View>
            </TouchableOpacity>
          </View>
        )}
      </RowView>
    </View>
  );
};

const pickerStyles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  period: {
    flex: 1,
    alignItems: 'center',
  },
  periodText: {
    fontSize: 22,
  },
  periodTextSelected: {
    color: Color.accent,
  },
  periodSelected: {
    backgroundColor: Color.primary,
  },
  input: {
    height: 72,
    width: 88,
    backgroundColor: Color.text.extraLow,
    textAlign: 'center',
    fontSize: 42,
    ...CommonProperties.borderRadius2,
    ...CommonProperties.fontFamily,
  },
  space: {
    ...CommonProperties.px3,
    fontSize: 42,
  },
  twelveSection: {
    ...CommonProperties.ml3,
    backgroundColor: Color.text.extraLow,
    ...CommonProperties.borderRadius1,
    width: 60,
    overflow: 'hidden',
  },
});

export default TimePicker;
